import "core-js/modules/es.symbol";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.reduce";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-own-property-descriptors";
import "core-js/modules/es.object.keys";
import "core-js/modules/web.dom-collections.for-each";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LocalStorageBackend from 'i18next-localstorage-backend';
import HttpApi from 'i18next-http-backend';
import Backend from 'i18next-chained-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { I18nDefaultConfig } from "./..";
export var i18nInit = function i18nInit(_ref) {
  var _ref$supportedLngs = _ref.supportedLngs,
      supportedLngs = _ref$supportedLngs === void 0 ? I18nDefaultConfig.supportedLngs : _ref$supportedLngs,
      _ref$fallbackLng = _ref.fallbackLng,
      fallbackLng = _ref$fallbackLng === void 0 ? I18nDefaultConfig.fallbackLng : _ref$fallbackLng,
      _ref$loadPath = _ref.loadPath,
      loadPath = _ref$loadPath === void 0 ? I18nDefaultConfig.loadPath : _ref$loadPath,
      _ref$useSuspense = _ref.useSuspense,
      useSuspense = _ref$useSuspense === void 0 ? I18nDefaultConfig.useSuspense : _ref$useSuspense,
      _ref$version = _ref.version,
      version = _ref$version === void 0 ? I18nDefaultConfig.version : _ref$version;
  var versions = supportedLngs.reduce(function (acc, name) {
    return _objectSpread({}, acc, _defineProperty({}, name, version));
  }, {});
  return i18n.use(Backend).use(LanguageDetector).use(initReactI18next).init({
    backend: {
      backends: [LocalStorageBackend, HttpApi],
      backendOptions: [{
        prefix: 'i18next_res_',
        expirationTime: 7 * 24 * 60 * 60 * 1000,
        defaultVersion: '',
        versions: versions,
        store: window.localStorage
      }, {
        loadPath: loadPath
      }]
    },
    detection: {
      order: ['path', 'cookie', 'localStorage', 'sessionStorage', 'navigator', 'htmlTag'],
      lookupFromPathIndex: 0
    },
    fallbackLng: fallbackLng,
    supportedLngs: supportedLngs,
    debug: process.env.NODE_ENV === 'development',
    keySeparator: false,
    // we do not use keys in form messages.welcome
    interpolation: {
      escapeValue: false // react already safes from xss

    },
    parseMissingKeyHandler: function parseMissingKeyHandler() {
      return ' ';
    },
    react: {
      useSuspense: useSuspense
    }
  });
};
export default i18n;